module.exports = __webpack_public_path__ + "static/media/Integrated_Bridge_Consoles_01.bc88007f.jpg";